import api from "./api"
import { toast } from "react-toastify";

export const CreateKey = async (keyType, keyValue, navigate) =>{
    const bank = localStorage.getItem('bank')
    const bankBranch = localStorage.getItem('bankBranch')
    const bankAccount = localStorage.getItem('bankAccount')
    const bankAccountDigit = localStorage.getItem('bankAccountDigit')
    const taxNumber = localStorage.getItem('taxNumber')

    let response = await api.post('/pixkey/store', {
        bank,
        bankBranch,
        bankAccount,
        bankAccountDigit,
        taxNumber,
        pixKey : keyValue,
        pixKeyType : keyType
    })
    if(response.status === 200){
        toast.success('Chave Criada com Sucesso!')
        setTimeout(() => {
            navigate('/chave-pix')
        }, 2000);
    }else{
        toast.error('Erro ao criar uma nova chave!')
    }
}

export const getAll = async () =>{

    let response = await api.post('/pixkey/list/', {
        personId : localStorage.getItem('personId')
    })
    if(response.status === 200){
        return response.data.data
    }else{
        toast.error('Erro ao carregar as chaves!')
    }
}

export const deleteKey = async (id, navigate) =>{
    if(window.confirm('Deseja realmente deletar essa chave pix?')){
        let deleteResponse = await api.delete(`/pixkey/delete/${id}`)
        if(deleteResponse.status === 200){
            toast.success('Chave Deletada com Sucesso!')
            setTimeout(() => {
                navigate('/chave-pix')
            }, 2000);
        }else{
            toast.error('Erro ao deletar a chave!')
        }
    }
}